import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { content } from "./shared/routes/routes";
import { LoginComponent } from "./components/pages/login/login.component";
import { AdminGuard } from "./shared/guard/admin.guard";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { RoleGuard } from "./shared/guard/role.guard";
import { Error403Component } from "./shared/components/error403/error403.component";
import { NotifyComponent } from "./shared/components/notify/notify.component";
import { Error404Component } from "./shared/components/error404/error404.component";
const routes: Routes = [
  {
    path: "",
    redirectTo: "/home",
    pathMatch: "full",
    canActivate: [RoleGuard],
    data: { roles: ["admin", "user", "customer"] }, // all roles allowed
  },
  {
    path: "auth/login",
    component: LoginComponent,
  },
  {
    path: "error403",
    component: Error403Component,
  },
  {
    path: "error404",
    component: Error404Component,
  },
  {
    path: "notify",
    canActivate: [RoleGuard],
    component: NotifyComponent,
    data: { roles: ["admin", "user", "customer"] },
  },
  {
    path: "",
    component: ContentComponent,
    canActivate: [RoleGuard],
    data: { roles: ["admin", "user", "customer"] }, // all roles allowed
    children: content,
  },
  {
    path: "",
    component: FullComponent,
    canActivate: [RoleGuard],
    data: { roles: ["admin", "user", "customer"] }, // all roles allowed
    children: full,
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        enableTracing: false,
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
    ],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
